import { getRequestErrorType } from './getRequestErrorType';

/* See getRequestErrorType for what counts as aborted. Mirrors the in-app
 * pricing-pages-ui/static/js/v2/utils/apiLogging#isAbortedQueryError, which
 * does not yet make the timeout distinction. */
export const isAbortedQueryError = error => error !== undefined && getRequestErrorType(error) === 'aborted';